import React from "react";
import { useGlobal, MESES_LARGOS } from "@/context/GlobalContext";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { StructureIcon } from "@/components/StructureIcon";
import { ChevronRight, CalendarDays } from "lucide-react";

const ANIOS = Array.from({ length: new Date().getFullYear() - 2023 }, (_, i) => 2024 + i);

export default function ContextBar() {
  const { currentStructure, node, period, setPeriod } = useGlobal();

  return (
    <div className="flex items-center gap-2 lg:gap-5 w-full">
      {/* Estructura + ruta (solo visual) */}
      <div className="flex items-center gap-2 flex-1 min-w-0 overflow-hidden" data-testid="context-breadcrumb">
        {currentStructure && (
          <span className="flex items-center gap-1.5 text-xs font-semibold px-2.5 py-1 rounded-md shrink-0"
            style={{ backgroundColor: `${currentStructure.color}22`, color: currentStructure.color }}>
            <StructureIcon name={currentStructure.icon} className="w-3.5 h-3.5" />
            <span className="hidden sm:inline">{currentStructure.name}</span>
          </span>
        )}
        {node?.path ? node.path.map((p, i) => (
          <React.Fragment key={p.id}>
            <ChevronRight className="w-3.5 h-3.5 text-slate-600 shrink-0 hidden md:inline" />
            <span className={`truncate hidden md:inline ${i === node.path.length - 1 ? "text-white font-medium" : "text-slate-400"}`}>{p.name}</span>
          </React.Fragment>
        )) : (
          <>
            <ChevronRight className="w-3.5 h-3.5 text-slate-600 shrink-0 hidden md:inline" />
            <span className="truncate hidden md:inline text-white font-medium" data-testid="context-entire-structure">Toda la estructura</span>
          </>
        )}
      </div>

      {/* Periodo: solo mes y año seleccionables */}
      <div className="flex items-center gap-2 shrink-0">
        <CalendarDays className="w-4 h-4 text-red-500 hidden sm:block" />
        <Select value={String(period.monthIndex)} onValueChange={(v) => setPeriod({ ...period, monthIndex: Number(v) })}>
          <SelectTrigger className="h-9 w-[108px] sm:w-[130px] bg-[#131C2E] border-[#223048] text-white" data-testid="context-period-select">
            <SelectValue />
          </SelectTrigger>
          <SelectContent className="bg-[#131C2E] border-[#223048] text-slate-200">
            {MESES_LARGOS.map((m, i) => (
              <SelectItem key={m} value={String(i)} data-testid={`period-opt-${i}`}>{m}</SelectItem>
            ))}
          </SelectContent>
        </Select>
        <Select value={String(period.year)} onValueChange={(v) => setPeriod({ ...period, year: Number(v) })}>
          <SelectTrigger className="h-9 w-[78px] sm:w-[90px] bg-[#131C2E] border-[#223048] text-white" data-testid="context-year-select">
            <SelectValue />
          </SelectTrigger>
          <SelectContent className="bg-[#131C2E] border-[#223048] text-slate-200">
            {ANIOS.map((y) => (
              <SelectItem key={y} value={String(y)} data-testid={`year-opt-${y}`}>{y}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
